// Normalises a product into selectable "variants". A variant is one image with
// its own size list — e.g. a two-piece offered in several styles, each with
// different sizes. The variant list is driven by the product's images; any
// per-image overrides (label + sizes) stored on `product.variants` are merged
// in by image URL. Images without an override fall back to the product's
// default `sizes`, so older products keep working unchanged.

export function getProductVariants(product) {
  if (!product) return [];

  const baseSizes = Array.isArray(product.sizes) ? product.sizes.filter(Boolean) : [];
  const overrides = Array.isArray(product.variants)
    ? product.variants.filter(v => v && v.image)
    : [];

  const imgs = (Array.isArray(product.images) && product.images.length)
    ? product.images.filter(Boolean)
    : [product.imageUrl || product.image_url].filter(Boolean);

  if (imgs.length) {
    return imgs.map(img => {
      const o = overrides.find(v => v.image === img);
      return {
        image: img,
        label: (o && o.label) || '',
        sizes: (o && Array.isArray(o.sizes) && o.sizes.length) ? o.sizes.filter(Boolean) : baseSizes,
        // Admin can flag an individual photo (style) as out of stock — it's
        // blurred and can't be added to cart on the storefront.
        unavailable: !!(o && o.unavailable),
      };
    });
  }

  // No images on the product but variant overrides carry their own image URLs.
  if (overrides.length) {
    return overrides.map(o => ({
      image: o.image,
      label: o.label || '',
      sizes: (Array.isArray(o.sizes) && o.sizes.length) ? o.sizes.filter(Boolean) : baseSizes,
      unavailable: !!o.unavailable,
    }));
  }

  return [];
}
